import { useTranslation } from 'react-i18next'

export default ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const label = t('Flag of Ireland.', { context: 'alt text for image of the IE flag' })

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="18"
      viewBox="0 0 122 84"
      fill="none"
      aria-label={label}
      className={className}
    >
      <path fill="#fff" fillRule="evenodd" d="M0 0h122v84H0V0Z" clipRule="evenodd" />
      <path fill="#009A49" fillRule="evenodd" d="M0 0h40.66v84H0V0Z" clipRule="evenodd" />
      <path fill="#FF7900" fillRule="evenodd" d="M81.34 0H122v84H81.34V0Z" clipRule="evenodd" />
    </svg>
  )
}
